export default __webpack_public_path__ + "static/media/Ring of Insightful Action.3081390b.jpg";